import { createFileRoute } from "@tanstack/react-router";

import { ActivitiesPage } from "../components/activities/ActivitiesPage";

export type ActivitiesSearch = {
  readonly mock?: string;
  readonly day?: string;
};

export const Route = createFileRoute("/activities")({
  validateSearch: (raw: Record<string, unknown>): ActivitiesSearch => ({
    ...(typeof raw.mock === "string" ? { mock: raw.mock.slice(0, 1) } : {}),
    ...(typeof raw.day === "string" && /^\d{4}-\d{2}-\d{2}$/.test(raw.day) ? { day: raw.day } : {}),
  }),
  component: ActivitiesPage,
});
